import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  isLayoutVisible = true;
  constructor() { }

  getLayoutVisibility() {
    return this.isLayoutVisible;
  }

  setLayoutVisibility(value: boolean) {
    this.isLayoutVisible = value;
  }
}
